import * as Yup from "yup";

export const initialValues = {
  workInLocationId: null,
};

const employeeWorkInLocationSchema = Yup.object().shape({
  workInLocationId: Yup.string().required("Please enter."),
});

export default employeeWorkInLocationSchema;
